import { render } from "./FormGroupPopup.vue?vue&type=template&id=761a8a8b&ts=true"
import script from "./FormGroupPopup.vue?vue&type=script&lang=ts"
export * from "./FormGroupPopup.vue?vue&type=script&lang=ts"

import "./FormGroupPopup.vue?vue&type=style&index=0&id=761a8a8b&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__